import React from "react";
import "./style.css";
export default function LineSeparator() {
  return <div className="line-separator" />;
}
